import React, {FC, useEffect, useRef, useState} from 'react';
import moment from 'moment'
import {useUnit} from "effector-react";
import {$userId} from "../Store/Store";
import Linkify from 'linkify-react';
import ReadStatusIcon from "./ReadStatusIcon";
import {instance} from "../api/Chat";

interface MessageInterface {
    id: number,
    sender_id: number,
    recipient_id: number,
    content: string,
    created_at: string,
    is_read: boolean
}

const Message: FC<MessageInterface> = ({
                                           id,
                                           sender_id,
                                           recipient_id,
                                           content,
                                           created_at,
                                           is_read
                                       }) => {
    const date = moment(created_at).format('HH:mm')
    const [userId] = useUnit([$userId])
    const [imageSrc, setImageSrc] = useState<string | null>(null);
    useEffect(() => {
        if (content.startsWith('image://')) {
            const protocol = 'image://';
            const path = content.slice(protocol.length);

            const fetchImage = async () => {
                try {
                    const res = await instance.get('/image/' + path, {
                        responseType: 'blob', // если сервер возвращает файл
                    });

                    const imageUrl = URL.createObjectURL(res.data);
                    setImageSrc(imageUrl);
                } catch (error) {
                    console.error('Ошибка при загрузке изображения:', error);
                }
            };

            fetchImage();
        }
    }, [content]);


    return (
        <div className={sender_id === userId ? `message-box my` : `message-box`}>
            <Linkify options={{className: 'linkify'}}>
                <div>
                    {
                        imageSrc ?
                            (
                                <img src={imageSrc} className={'message-box-image'} alt="Изображение" loading='lazy'/>
                            )
                            :
                            (
                                <p className="message-box-content">{content}</p>
                            )
                    }

                </div>
            </Linkify>
            <div className="flex flex-end">
                <span className="message-box-time">{date}</span>
                {
                    sender_id === userId && <ReadStatusIcon isRead={is_read}/>
                }
            </div>
        </div>
    )
};
export default Message;
